import React from 'react';
import {
	FireScreenAnalytics,
	ContextualAnalyticsData,
	DRAWER,
} from '@atlassian/jira-product-analytics-bridge';
import { SidebarDataHandler } from '../../common/async-handler/index.tsx';
import { useNumberFieldStatistics } from '../../services/number-field/index.tsx';
import { NumericStatsTable } from './numeric-stats-table/index.tsx';

type Props = {
	customFieldId: string;
	query: string;
};

export const NumericStatsContainer = ({ customFieldId, query }: Props) => {
	const [{ loading, data, error }] = useNumberFieldStatistics({
		customFieldId,
		query,
	});

	const isDataEmpty =
		data?.count === 0 ||
		(data?.min === undefined && data?.max === undefined && data?.sum === undefined);

	return (
		<SidebarDataHandler error={error} loading={loading} data={data} isEmpty={isDataEmpty}>
			<ContextualAnalyticsData
				sourceType={DRAWER}
				sourceName="jira.issueFieldStatistics.numericStats"
			>
				<FireScreenAnalytics />
				{data && <NumericStatsTable data={data} />}
			</ContextualAnalyticsData>
		</SidebarDataHandler>
	);
};
